module.exports = __webpack_public_path__ + "static_pc/img/ba05.d9af3dbd.png";